import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./RecapitulationReportUIHelpers";

const RecapitulationReportUIContext = createContext();

export function useRecapitulationReportUIContext() {
  return useContext(RecapitulationReportUIContext);
}

export const RecapitulationReportUIConsumer =
  RecapitulationReportUIContext.Consumer;

export function RecapitulationReportUIProvider({
  recapitulationReportUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initRecapitulationReport = {
    organization_uuid: "",
    date: "",
    fund_type: "",
    program_uuid: "",
    project_uuid: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initRecapitulationReport,
    newRecapitulationReportButtonClick:
      recapitulationReportUIEvents.newRecapitulationReportButtonClick,
    openEditRecapitulationReportPage:
      recapitulationReportUIEvents.openEditRecapitulationReportPage,
    openRecapitulationReportFilePage:
      recapitulationReportUIEvents.openRecapitulationReportFilePage
  };

  return (
    <RecapitulationReportUIContext.Provider value={value}>
      {children}
    </RecapitulationReportUIContext.Provider>
  );
}
